<template>
  <div class="page-my-project"
       :class="{ 'color-white': list.length === 0 }"
  >
    <ym-loadmore v-if="list.length > 0"
                 class="list"
                 v-model="loading"
                 :finished="allLoad"
                 @load="fetchData"

    >
      <div class="project-item"
           v-for="(item, index) in list"
           :key="index"
      >
        <div class="project-info"
             @click="handleProjectDetail(item.id)"
        >
          <cover class="cover"
                 :cover="item.cover"
                 :alt="item.title"
          />
          <div class="info">
            <h3 class="project-title ym-two-line-ellipsis">{{ item.title }}</h3>
            <span class="status"
                  :class="{
                   'active': item.status !== 'ended',
                   'default':  item.status === 'ended',
                  }"
            >
              {{ formatStatusDesc(item.status, item.joinStatus) }}
            </span>
            <span class="project-date ym-line-ellipsis"
                  v-if="item.desc"
            >
              {{ item.desc }}
            </span>
          </div>
        </div>
        <div class="project-tool">
          <ym-button class="customer"
                     size="extra-small"
                     type="gray"
                     plain
                     @click="handleCustomer(item.id)"
          >
            联系客服
          </ym-button>
          <div class="tool">
            <ym-button class="project-work"
                       size="extra-small"
                       type="gray"
                       plain
                       @click="handleProjectWork(item.id, user.id)"
                       v-if="item.showImpressionEntrance"
            >
              研学收获
            </ym-button>
            <template v-if="item.status === 'ended'">
              <ym-button class="evaluate"
                         size="extra-small"
                         type="primary"
                         plain
                         @click="handleProjectReview(item.id)"
              >
                评价项目
              </ym-button>
            </template>
            <template v-else>
              <ym-button size="extra-small"
                         class="evaluate"
                         type="primary"
                         plain
                         disabled
              >
                评价项目
              </ym-button>
            </template>
          </div>
        </div>
      </div>
    </ym-loadmore>
    <empty-page hint="你还没有参加相关线下项目哦！"
                v-if="allLoad && list.length === 0"
    />
  </div>
</template>

<script>
  import { Button, Loadmore } from '@ymba/ym-ui';
  import { getMyProjectData } from '@/services/user';
  import { LIMIT } from '@/utils/constant';
  import EmptyPage from '@/components/EmptyPage';
  import Cover from '@/components/ProductCover';

  export default {
    name: 'PageMyProject',
    metaInfo: {
      title: '线下项目',
    },
    components: {
      'ym-loadmore': Loadmore,
      'ym-button': Button,
      EmptyPage,
      Cover,
    },
    data() {
      return {
        start: 0,
        list: [],
        loading: false,
        allLoad: false,
        user: null,
      };
    },
    methods: {
      formatStatusDesc(status, joinStatus) {
        if (status === 'ended') return '已结束';
        if (joinStatus === 'member') return '已加入';
        return '已支付定金';
      },
      async fetchData(isLoadMore = true) {
        if (this.allLoad) return;
        this.loading = true;
        const data = await getMyProjectData({
          limit: LIMIT,
          start: this.start,
        }, isLoadMore);

        if (data.list.length === 0) {
          this.allLoad = true;
          this.loading = false;
          return;
        }
        this.user = data.user;
        this.list = [...this.list, ...data.list];
        this.start = data.start;
        this.loading = false;
      },
      handleChallengeDetail(id) {
        this.$router.push({ name: 'ChallengeList', params: { id } });
      },
      handleProjectReview(id) {
        const route = { name: 'CreateReview', params: { type: 'project', id } };
        this.$router.push(route);
      },
      handleProjectDetail(id) {
        const route = { name: 'ProjectDetail', params: { id } };
        this.$router.push(route);
      },
      handleCustomer(id) {
        this.$router.push({ name: 'CustomerService', params: { id, type: 'project' } });
      },
      handleProjectWork(projectId, userId) {
        this.$router.push({ name: 'ProjectWork', params: { projectId, userId } });
      },
    },
    created() {
      this.fetchData();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-my-project {
    height: 100%;
    &.color-white {
      background: @color-white;
    }
  }

  .project-item {
    margin-top: @size-small;
    padding: @size-medium @size-base @size-base;
    background: @color-white;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    position: relative;
  }

  .project-info {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-bottom: @size-small;
    padding-bottom: @size-base;
    border-bottom: @border-base;
  }

  .cover {
    margin-right: @size-base;
  }

  .info {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .project-title {
    font-size: @font-size-base;
    margin: 0;
    width: 460px;
    color: @color-text-base;
    font-weight: @font-weight-primary;
    line-height: 1.4;
  }

  .project-date {
    width: 460px;
    font-size: @font-size-small;
    font-weight: @font-weight-primary;
    color: @color-text-lighter;
    line-height: 1;
  }

  .status {
    width: fit-content;
    padding: 2px 12px;
    border-radius: @border-radius-large;
    font-size: @font-size-extra-extra-small;
    color: @color-text-light;
    &.active {
      color: @color-primary-aide;
      background: @color-primary-lighter;
    }
    &.default {
      color: @color-text-lighter;
      background: @color-gray-lighter;
    }
  }

  .project-tool {
    margin-top: @size-extra-small;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .customer {
    margin-right: @size-small;
    border-radius: 2 * @border-radius-medium;
  }

  .evaluate {
    border-radius: @border-radius-base;
  }

  .project-work {
    margin-right: @size-small;
  }

  /deep/ .mint-tab-container,
  /deep/ .tab-content-container {
    overflow: visible;
  }

  /deep/ .tab-content-container,
  /deep/ .mint-tab-container-wrap {
    height: 100%;
  }
</style>
